export default __webpack_public_path__ + "static/media/seanor_logo.04fd145c.svg";